import * as React from 'react';
import { CnSelect, } from '@/components/cn-select';
import { handleRequestService } from './service';
import { useRequest } from 'ahooks';
import LRU from 'lru-cache';
import useInitRequest from './useInitRequest';
import { isFunction } from 'lodash';
const AsyncSelect = (props, ref) => {
    const baseSelectRef = React.useRef(null);
    const [lru] = React.useState(new LRU({
        max: 5000,
    }));
    const [searchLoading, setSearchLoading] = React.useState(false);
    const { remoteUrl: url, requestConfig = {}, initRequestConfig = {}, onVisibleChange: propOnVisibleChange, ...otherProps } = props;
    // 读取requestConfig
    const { service, searchFormat, ...otherRequestConfig } = requestConfig;
    // 请求地址，优先requestConfig，其次remoteUrl
    const remoteUrl = requestConfig.url || url;
    // 请求服务封装
    const requestService = handleRequestService(requestConfig, remoteUrl);
    // 初始请求服务，用于数据回显
    const initRequestService = handleRequestService(initRequestConfig, initRequestConfig?.url || url);
    // 通过useRequest返回数据
    const { runAsync, run, mutate, 
    // error,
    data = [],
    // loading,
     } = useRequest(requestService, {
        ready: !!(remoteUrl || service),
        ...otherRequestConfig,
    });
    React.useImperativeHandle(ref, () => ({
        mutateDataSource: mutate,
        sendRequest: run,
        ...(baseSelectRef?.current ?? {}),
    }));
    // 组装的select props
    const insertSelectProps = {};
    insertSelectProps.dataSource = data;
    insertSelectProps.onVisibleChange = (visible, reason) => {
        if (isFunction(propOnVisibleChange)) {
            propOnVisibleChange(visible, reason, run);
        }
    };
    // onSearch 自动包装
    // 仅在 showSearch 且 filterLocal 为 false 情况下启用
    const realSearch = otherProps.hasSearch || otherProps.showSearch;
    const enableOnSearch = realSearch && !otherProps.onSearch && props.filterLocal === false;
    if (enableOnSearch) {
        insertSelectProps.searchLoading = searchLoading;
        insertSelectProps.onSearch = async (inputValue) => {
            setSearchLoading(true);
            try {
                await runAsync(inputValue);
            }
            catch (error) {
                console.error(error);
            }
            setSearchLoading(false);
        };
    }
    // 数据源缓存
    React.useEffect(() => {
        data?.forEach((item) => {
            lru.set(item.value, Promise.resolve(item));
        });
        otherProps.dataSource?.forEach((item) => {
            lru.set(item.value, Promise.resolve(item));
        });
    }, [data, otherProps.dataSource, lru]);
    const { value, filterLocal, useDetailValue } = props;
    // 根据value做数据回显
    useInitRequest({
        value,
        filterLocal,
        useDetailValue,
        requestService,
        initRequestService,
        lru,
        mutate,
    });
    return (
    // @ts-ignore ref
    React.createElement(CnSelect, { ref: baseSelectRef, ...insertSelectProps, ...otherProps }));
};
const CnAsyncSelect = React.forwardRef(AsyncSelect);
CnAsyncSelect.displayName = 'CnAsyncSelect';
export default CnAsyncSelect;
